module.exports = __webpack_public_path__ + "img/Converter.2907c4f8.svg";